<template>
    <div data-aos="fade-in" class="menu-navigation">
        <ul class="menu-navbar">
            <li @click="setCurrentCategory($event, category)" 
                :class="{'active' : selectedCategory.id === category.id}" 
                v-for="(category) in categories.items" 
                :key="category.id">
                <a href="">{{ category.name }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    methods: {
        setCurrentCategory: function(e, category) {
            e.preventDefault()
            this.$emit('clicked', category)
        },
    },
    props: ['selectedCategory', 'categories']
}
</script>

<style lang="scss" scoped>
    .menu-navigation {
        font-size: 1em;
        margin-bottom: 1rem;        
        overflow-x: scroll;
        .menu-navbar {
            display: flex;            
            margin-top: 0;  
            margin-bottom: 0;
            padding-left: 0;
            list-style: none;
            text-align: center;
            li {
                border: 2px solid rgb(255, 254, 245);
                background-color: #3e3838;  
                height: 5rem; 
                width: 8rem;
                padding: .5rem;
                margin-left: -2px;
                display: table;
                &:hover {
                    background-color: #e74c3c;
                }
                &.active {
                    background-color: #e74c3c;
                }
                a {
                    word-wrap: break-word;
                    color: white;
                    text-decoration: none;
                    display: table-cell;
                    vertical-align: middle;
                    font-weight: bold; 
                }
            }
        }
    }
/* On screens that are 600px or less */
@media screen and (max-width: 1200px) {
    .menu-navigation {
        .menu-navbar {
            li {
                padding: 0 2rem 0 2rem;
                box-sizing:content-box;
            }
        }
    }
}
</style>

